module.exports = __webpack_public_path__ + "img/hj2.1ea89f78.jpg";